// import React from 'react';
// import { useNavigate } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom'; // v5 equivalent
// import { useNavigate } from 'react-router-dom';
import { notification } from 'antd'; // Ant Design notification
import { getLogin, getTokenForUser } from '../../../Apis/Auth';
import { useDispatch, useSelector } from 'react-redux';
import { AddUser } from '../../../Redux/Actions/User';
const CrossAuth = React.forwardRef((props, ref) => {
  const history = useHistory();
  const [message, setMessage] = useState('Processing authentication...');
  const dispatch = useDispatch();
  //   const token =
  //     'JQpZo5opQCzEtPfEmKIUtCqeDBI0X6LSxPMlMoAt7JGMQ8Cn2jiCtnDB5OtX1sz6sLWMwixo3afw6U4rJ0u19jS8OhHGz9Cv1UvuTJuOqjJjVXLaleDfIAuoI77x08pLcHz8sBoVCKfq6rcd5q8HCdybMmBSnjj3tEBNb8z9YOxzMwJsCkKjHJ25oIMlDEmkg6dUy4pgrANvvVyxe/0/cu0+GQsEpll+03w6+5OPwxk=';
  //   const encodedToken = encodeURIComponent(token);
  useEffect(() => {
    console.log('dterd');

    // async function handleCrossAuth() {
    //   try {
    //     console.log('dterd1');
    //     // 1️⃣ Get params
    //     const params = new URLSearchParams(window.location.search);
    //     const redirectUrlBase64 = params.get('redirect-url');
    //     const encryptedKey = encodeURIComponent(params.get('encryptedKey'));

    //     if (!redirectUrlBase64 || !encryptedKey) {
    //       setMessage('Invalid request: Missing required parameters');
    //       return;
    //     }

    //     // 2️⃣ Decode redirect URL
    //     let redirectUrl;
    //     try {
    //       redirectUrl = atob(redirectUrlBase64);
    //     } catch (err) {
    //       console.log('dterd');
    //       setMessage('Invalid redirect URL');
    //       return;
    //     }
    //     console.log('dterd3');

    //     console.log('dterd3');

    //     getLogin(encryptedKey)
    //       .then(response => {
    //         if (
    //           response.data &&
    //           response.data.success &&
    //           response.data.result?.length > 0
    //         ) {
    //           const currentUser = response.data.result[0]; // First (and likely only) user object
    //           const {
    //             firstName,
    //             lastName,
    //             token,
    //             sessionId,
    //             facilities,
    //             threeLeggedAuth
    //           } = currentUser;

    //           // Store important session data
    //           sessionStorage.setItem('authToken', token);
    //           sessionStorage.setItem('sessionId', sessionId);
    //           sessionStorage.setItem('userName', `${firstName} ${lastName}`);
    //           sessionStorage.setItem('facilities', JSON.stringify(facilities));

    //           // You might want to use some other check instead of email
    //           if (threeLeggedAuth) {
    //             // Valid → redirect
    //             window.location.href = redirectUrl;
    //           } else {
    //             // Not authorized for redirect
    //             setMessage('Unable to redirect, authentication mismatch.');
    //             notification.error({
    //               message: 'User mismatch',
    //               description:
    //                 'Please logout and login with the correct account.'
    //             });
    //           }
    //         } else {
    //           // No user found → go to login
    //           sessionStorage.setItem('postLoginRedirect', redirectUrl);
    //           history.push('/login');
    //         }
    //       })
    //       .catch(error => {
    //         console.error('getLogin error:', error);
    //         setMessage('Error checking current login.');
    //       });

    //     const loginResponse = '';
    //     // await res.json();
    //     const apiEmail = loginResponse?.email;

    //     // 4️⃣ Check current logged-in user
    //     // Replace with your actual user session getter
    //     const currentUser = JSON.parse(
    //       localStorage.getItem('currentUser') || 'null'
    //     );

    //     if (!currentUser) {
    //       // No user logged in → redirect to login
    //       localStorage.setItem('postLoginRedirect', redirectUrl);
    //       history.push('/login');
    //       return;
    //     }

    //     if (currentUser.email === apiEmail) {
    //       // Same user → redirect
    //       window.location.href = redirectUrl;
    //     } else {
    //       // Different user
    //       setMessage('Unable to redirect, please logout & login');
    //     }
    //   } catch (error) {
    //     console.error('Cross-auth error:', error);
    //     setMessage('An error occurred during authentication.');
    //   }
    // }

    // async function handleCrossAuth() {
    //   console.log('🔍 Starting CrossAuth process...');

    //   try {
    //     // 1️⃣ Get params
    //     const params = new URLSearchParams(window.location.search);
    //     const redirectUrlBase64 = params.get('redirect-url');
    //     const encryptedKey = encodeURIComponent(params.get('encryptedKey'));

    //     console.log('📥 Query Params:', {
    //       'redirect-url (base64)': redirectUrlBase64,
    //       'encryptedKey (encoded)': encryptedKey
    //     });

    //     if (!redirectUrlBase64 || !encryptedKey) {
    //       setMessage('Invalid request: Missing required parameters');
    //       console.warn('⚠️ Missing redirect-url or encryptedKey.');
    //       return;
    //     }

    //     // 2️⃣ Decode redirect URL
    //     let redirectUrl;
    //     try {
    //       redirectUrl = atob(redirectUrlBase64);
    //       console.log('🔓 Decoded redirect URL:', redirectUrl);
    //     } catch (err) {
    //       setMessage('Invalid redirect URL');
    //       console.error('❌ Failed to decode redirect URL:', err);
    //       return;
    //     }

    //     // 3️⃣ Call API
    //     console.log('📡 Calling getLogin API with encryptedKey...');
    //     const response = await getLogin(encryptedKey);
    //     console.log('✅ API Response:', response);

    //     let currentUser = null;

    //     if (response?.data?.success && response.data.result?.length > 0) {
    //       currentUser = response.data.result[0];
    //       console.log('👤 Current User Data from API:', currentUser);
    //     } else {
    //       console.warn('❌ No user found in API — using token fallback.');

    //       // 🔹 Token fallback mode — decode and use directly
    //       currentUser = {
    //         firstName: 'Auto',
    //         lastName: 'Login',
    //         token: params.get('encryptedKey'), // or decode if needed
    //         sessionId: Date.now().toString(),
    //         facilities: [],
    //         threeLeggedAuth: true
    //       };
    //     }

    //     const {
    //       firstName,
    //       lastName,
    //       token,
    //       sessionId,
    //       facilities,
    //       threeLeggedAuth
    //     } = currentUser;

    //     console.log('🗝 Extracted User Details:', {
    //       firstName,
    //       lastName,
    //       token,
    //       sessionId,
    //       facilities,
    //       threeLeggedAuth
    //     });

    //     // 4️⃣ Save session
    //     sessionStorage.setItem('authToken', token);
    //     sessionStorage.setItem('sessionId', sessionId);
    //     sessionStorage.setItem('userName', `${firstName} ${lastName}`);
    //     sessionStorage.setItem('facilities', JSON.stringify(facilities));
    //     localStorage.setItem('currentUser', JSON.stringify(currentUser));

    //     // 5️⃣ Redirect
    //     if (threeLeggedAuth) {
    //       const separator = redirectUrl.includes('?') ? '&' : '?';
    //       const finalUrl = `${redirectUrl}${separator}token=${encodeURIComponent(
    //         token
    //       )}`;
    //       console.log('🚀 Redirecting to:', finalUrl);
    //     //   return;
    //       setTimeout(() => {
    //         window.location.href = finalUrl;
    //       }, 1500); // Delay for debugging
    //     } else {
    //       console.warn('⚠️ Authentication mismatch: threeLeggedAuth is false.');
    //       setMessage('Authentication mismatch.');
    //     }
    //   } catch (error) {
    //     console.error('💥 Cross-auth error:', error);
    //     setMessage('An error occurred during authentication.');
    //   }
    // }
    async function handleCrossAuth() {
      try {
        // 1️⃣ Get params
        const params = new URLSearchParams(window.location.search);
        const redirectUrlBase64 = params.get('redirect-url');
        const encryptedKey = encodeURIComponent(params.get('encryptedKey'));

        if (!redirectUrlBase64 || !encryptedKey) {
          setMessage('Invalid request: Missing required parameters');
          return;
        }

        // 2️⃣ Decode redirect URL
        let redirectUrl;
        try {
          redirectUrl = atob(redirectUrlBase64);
        } catch (err) {
          setMessage('Invalid redirect URL');
          return;
        }

        // 3️⃣ Call getLogin API
        getLogin(encryptedKey)
          .then(response => {
            if (
              response.data &&
              response.data.success &&
              response.data.result?.length > 0
            ) {
              const data = response.data.result[0];

              // Save user/session data in localStorage
              dispatch(AddUser(data));
              localStorage.setItem('user', JSON.stringify(data));
              localStorage.setItem('loggedIn', true);
              sessionStorage.setItem('loginMethod', 'crossAuth');

              if (data.token) {
                localStorage.setItem('accessToken', data.token);
              }

              // ✅ Go directly to redirect URL
              if (data.userType === 'scribe') {
                if (redirectUrl.includes('/new-editor/')) {
                  // Flow 1: completed dictation in DFW — go to the job editor with scribe role
                  window.location.href = redirectUrl.replace('userRole=doctor', 'userRole=scribe');
                } else {
                  // Flow 2: "go to web" option — go to job listing
                  window.location.href = window.location.origin + '/dashboard/jobs-list/my-jobs/in-progress';
                }
              } else {
                window.location.href = redirectUrl;
              }
            } else {
              // No user found → go to login
              localStorage.setItem('postLoginRedirect', redirectUrl);
              history.push('/login');
            }
          })
          .catch(error => {
            console.error('getLogin error:', error);
            setMessage('Error checking current login.');
          });
      } catch (error) {
        console.error('Cross-auth error:', error);
        setMessage('An error occurred during authentication.');
      }
    }

    handleCrossAuth();
  }, [history]);

  return (
    <>
      <div style={{ padding: 20, fontFamily: 'sans-serif' }}>
        {/* <p>{message}</p> */}
      </div>
    </>
  );
});

export default CrossAuth;
